import { z } from 'zod';
import { PromptTaskTypeDbSchema } from '../constants/prompt-task-types.js';

// ─── PromptUsedIn — free text identifier for pipeline binding ───────

export const PromptUsedInSchema = z.string().trim().min(1, 'Used In is required').max(100);
export type PromptUsedIn = z.infer<typeof PromptUsedInSchema>;

/** UI suggestions — not enforced at the validation layer. */
export const PROMPT_USED_IN_SUGGESTIONS = ['Generate Opportunities', 'Generate Scripts'] as const;

// ─── PromptStatus ───────────────────────────────────────────────────

export const PromptStatusEnum = z.enum(['ACTIVE', 'INACTIVE']);
export type PromptStatus = z.infer<typeof PromptStatusEnum>;

// ─── Request schemas ────────────────────────────────────────────────

export const ListPromptsQuerySchema = z.object({
  usedIn: z.string().optional(),
  tenantId: z.string().optional(),
  status: PromptStatusEnum.optional(),
  taskType: PromptTaskTypeDbSchema.optional(),
});
export type ListPromptsQuery = z.infer<typeof ListPromptsQuerySchema>;

/** Nullable LLM model id persisted on PromptVersion. Null = service default. */
export const PromptModelIdSchema = z.string().trim().min(1).max(100);

export const CreatePromptBodySchema = z.object({
  name: z.string().trim().min(1, 'Name is required').max(255),
  usedIn: PromptUsedInSchema,
  tenantId: z.string().nullish(),
  content: z.string().min(1, 'Content is required'),
  model: PromptModelIdSchema.nullish(),
  /** Job type — TEXT | VISION | IMAGE. Defaults to TEXT when omitted. */
  taskType: PromptTaskTypeDbSchema.optional(),
});
export type CreatePromptBody = z.infer<typeof CreatePromptBodySchema>;

export const UpdatePromptBodySchema = z.object({
  name: z.string().trim().min(1).max(255).optional(),
  status: PromptStatusEnum.optional(),
  taskType: PromptTaskTypeDbSchema.optional(),
});
export type UpdatePromptBody = z.infer<typeof UpdatePromptBodySchema>;

export const CreateVersionBodySchema = z.object({
  content: z.string().min(1, 'Content is required'),
  model: PromptModelIdSchema.nullish(),
});
export type CreateVersionBody = z.infer<typeof CreateVersionBodySchema>;
